// import lib
import { isEmpty } from "../lib/isEmpty";

// Single source of truth for which attachments are accepted. The
// SupportTicket page mirrors this in the file <input accept="..."> so
// the OS picker, the validation, and the on-screen error message all
// agree (previously they didn't, which is what made the field appear
// to "accept PDFs/videos but reject them as not-an-image").
export const ALLOWED_ATTACHMENT_EXTENSIONS = [
    "jpg",
    "jpeg",
    "png",
    "webp",
    "avif",
    "gif",
    "pdf",
    "doc",
    "docx",
    "mp4",
    "mov",
    "avi",
];

export const ALLOWED_ATTACHMENT_ACCEPT = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif",
    "image/gif",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "video/mp4",
    "video/quicktime",
    "video/x-msvideo",
].join(",");

// Build a case-insensitive regex like /(\.jpg|\.jpeg|...|\.avi)$/i
const allowedExtensions = new RegExp(
    `(${ALLOWED_ATTACHMENT_EXTENSIONS.map((ext) => `\\.${ext}`).join("|")})$`,
    "i"
);

// Friendly message rendered on the form. Keep this in sync with the
// extension list above so the message never claims to allow more (or
// less) than the validator does.
const INVALID_EXTENSION_MSG = `Please upload a file with one of these extensions: ${ALLOWED_ATTACHMENT_EXTENSIONS
    .map((ext) => `.${ext}`)
    .join(", ")}.`;

// 25 MB — generous enough for PDFs/short videos but still bounded.
const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024;
const OVERSIZED_MSG = "File size should be less than 25 MB.";

const validation = (value, callFrom) => {
    if (callFrom == 'createTicket') {
        return createTicket(value)
    } else if (callFrom == 'replyMsg') {
        return replyMsg(value)
    }
}

const validateAttachment = (file, key) => {
    if (!file || typeof file !== "object") return null;

    const name = file.name || "";
    if (!name || isEmpty(name.match(allowedExtensions))) {
        return { [key]: INVALID_EXTENSION_MSG };
    }
    if (Number(file.size) > MAX_ATTACHMENT_BYTES) {
        return { [key]: OVERSIZED_MSG };
    }
    return null;
};

export const createTicket = value => {
    let errors = {};

    if (isEmpty(value.categoryId)) {
        errors.categoryId = "Category field is required"
    }

    if (isEmpty(value.message)) {
        errors.message = "Message field is required"
    }

    const attachmentError = validateAttachment(value?.attachment, "attachment");
    if (attachmentError) {
        Object.assign(errors, attachmentError);
    }

    return errors;
}

export const replyMsg = value => {
    let errors = {};

    if (isEmpty(value.rplyMessage)) {
        errors.rplyMessage = "Message field is required"
    }

    const attachmentError = validateAttachment(
        value?.rplyattachment,
        "rplyattachment"
    );
    if (attachmentError) {
        Object.assign(errors, attachmentError);
    }

    return errors;
}

export default validation;
